import { render, staticRenderFns } from "./FilaChatbot.vue?vue&type=template&id=7a182d24"
import script from "./FilaChatbot.vue?vue&type=script&lang=js"
export * from "./FilaChatbot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports